import React from "react";

const Filter = () => (
  <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.41667 11.5H4.58333C4.34022 11.5 4.10706 11.4034 3.93515 11.2315C3.76324 11.0596 3.66667 10.8264 3.66667 10.5833V7.10458L0.270417 3.70833C0.0982723 3.53721 0.00102336 3.30481 0 3.06208V1.41667C0 1.17355 0.0965771 0.940394 0.268485 0.768485C0.440394 0.596577 0.673552 0.5 0.916667 0.5H10.0833C10.3264 0.5 10.5596 0.596577 10.7315 0.768485C10.9034 0.940394 11 1.17355 11 1.41667V3.06208C10.999 3.30481 10.9017 3.53721 10.7296 3.70833L7.33333 7.10458V10.5833C7.33333 10.8264 7.23676 11.0596 7.06485 11.2315C6.89294 11.4034 6.65978 11.5 6.41667 11.5ZM0.916667 1.41667V3.06208L4.58333 6.72875V10.5833H6.41667V6.72875L10.0833 3.06208V1.41667H0.916667Z" fill="#96CEF6" />
  </svg>
);

export default Filter;
